
<div class="card-body">

<!--   <ngb-alert
    *ngIf="uploadId == '9f86d081884c7d659a2feaa0c55ad015a3bf4f1b2b0b822cd15d6c15b0f00a08'"
    type="success"
    [dismissible]="false"
    class="mt-4 mb-5">
    <p class="mb-0">
      <fa-icon [icon]="['fas', 'exclamation-circle']" size="md" data-placement="top" title="waiting icon" class="mr-3"></fa-icon>
      This is an example analysis for a file <code>Test-yara.txt</code>. Please check a analysis for a malicious file <a class="underline" (click)="reload('9f86d081884c7d659a2feaa0c55ad015a3bf4f1b2b0b822cd15d6c15b0f00a09')"><code>x-script</code></a>.
    </p>
  </ngb-alert>

  <ngb-alert
    *ngIf="uploadId == '9f86d081884c7d659a2feaa0c55ad015a3bf4f1b2b0b822cd15d6c15b0f00a09'"
    type="success"
    [dismissible]="false"
    class="mt-4 mb-5">
    <p class="mb-0">
      <fa-icon [icon]="['fas', 'exclamation-circle']" size="md" data-placement="top" title="waiting icon" class="mr-3"></fa-icon>
      This is an example analysis for a file <code>x-script</code>. Please check a analysis for a regular file <a class="underline" (click)="reload('9f86d081884c7d659a2feaa0c55ad015a3bf4f1b2b0b822cd15d6c15b0f00a08')"><code>Test-yara.txt</code></a>.
    </p>
  </ngb-alert> -->

  <div class="row">
    <div class="col-4">
      <highcharts-chart
          [Highcharts]="Highcharts"
          [options]="pieChartOptions"
          [(update)]="updateDonutFlag"
          [oneToOne]=true
          style="width: 100%; display: block; max-width: 400px; margin-left: auto; margin-right: auto;"
          ></highcharts-chart>
    </div>
    <div class="col-8">
      <div class="card">
        <h5 class="card-header d-flex flex-row justify-content-between align-items-center">
          <p class="align-middle mb-0" *ngIf="signaturesInfected == 0 && !scanNotFound">
            <fa-icon [icon]="['fas', 'check-circle']" size="md" data-placement="top" title="waiting icon" class="mr-3"></fa-icon>
            No engines detected this file
          </p>
          <p class="align-middle mb-0" *ngIf="signaturesInfected > 0 && !scanNotFound">
            <fa-icon [icon]="['fas', 'exclamation-circle']" size="md" data-placement="top" title="waiting icon" class="mr-3"></fa-icon>
            {{signaturesInfected}} engines detected this file
          </p>
          <p class="align-middle mb-0" *ngIf="scanNotFound">
            <fa-icon [icon]="['fas', 'exclamation-circle']" size="md" data-placement="top" title="waiting icon" class="mr-3"></fa-icon>
            No engines response received
          </p>
          <!-- <div>
            <button href="#" class="btn btn-primary mr-1" (click)="rescan()">Rescan</button>
            <button href="#" class="btn btn-primary">Download</button>
          </div> -->
        </h5>
        <div class="card-body">
          <div class="row">
            <div class="col-8">
              <p class="lead font-bold">{{scanNotFound ? "scan not found" : vitalNames[0]}}</p>
              <p class="text-muted">
                {{ scanNotFound ? "--" : vitalBasicProperties.sha256 }}
              </p>
              <p>
                <span class="badge badge-secondary">{{ scanNotFound ? "--" : vitalBasicProperties.mimeType }}</span>
              </p>
            </div>
            <div class="col-4 text-right">
              <p *ngIf="isDateDefined(vitalHistory?.lastAnalysis)">
                {{vitalHistory.lastAnalysis | date: 'mediumDate'}} <span class="badge">DATE</span>
              </p>
              <p *ngIf="!isDateDefined(vitalHistory?.lastAnalysis)">
                -- <span class="badge">DATE</span>
              </p>
              <p>
                {{vitalBasicProperties?.fileSize | humanFileSize }} <span class="badge">SIZE</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<br/>
<br/>

<ngb-alert type="info" *ngIf="analysisPending" [dismissible]="false">
  <fa-icon [icon]="['fas', 'stopwatch']" size="lg" data-placement="top" title="waiting icon" class="mr-3"></fa-icon>
  Analysis is pending...
</ngb-alert>


<ngb-alert type="warning" *ngIf="scanNotFound" [dismissible]="false" class="flex flew-row justify-content-between align-items-center">
  <p class="align-middle mb-0">
    <fa-icon [icon]="['fas', 'exclamation-circle']" size="lg" data-placement="top" title="waiting icon" class="mr-3"></fa-icon>
    Scan not found
  </p>
  <!-- <button type="button" class="btn btn-secondary" (click)="rescan()">Rescan</button> -->
</ngb-alert>

<br/>
<br/>

<div class="card-body" *ngIf="!scanNotFound">
  <div class="row pt-3">
    <div class="col-1"></div>
    <div class="col-10">
      <ul class="nav nav-tabs nav-tabs-light">
        <li class="nav-item" data-toggle="tooltip" data-placement="top" title="{{ 'pages.assets.dashboard.assetContractDesc' | translate }}">
          <a class="nav-link" [ngClass]="{ 'active' : page === 'engines' }" (click)="page = 'engines';">Engines</a>
        </li> 
        <li class="nav-item" data-toggle="tooltip" data-placement="top" title="{{ 'pages.assets.dashboard.assetFlagDesc' | translate }}">
          <a class="nav-link" [ngClass]="{ 'active' : page === 'details' }" (click)="page = 'details';">Details</a>
        </li>
        <li class="nav-item" data-toggle="tooltip" data-placement="top" title="{{ 'pages.assets.dashboard.assetFlagDesc' | translate }}">
          <a class="nav-link" [ngClass]="{ 'active' : page === 'links' }" (click)="page = 'links';">Links</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="card-body" *ngIf="page == 'engines'">

    <div class="row pt-3" *ngIf="enginesScan?.length > 0">
      <div class="col-1"></div>
      <div class="col-10">
    
                  <div class="row faketableheaderrow">
                      <div class="col-2 faketableheader text-left" >
                          Engine
                      </div>
                      <div class="col-2 faketableheader text-left" >
                          Version 
                      </div>
                      <div class="col-3 faketableheader text-left" >
                          Analysis Date
                      </div>
                      <div class="col-2 faketableheader text-left" >
                          Update Date
                      </div>
                      <div class="col-3 faketableheader text-right">
                          Signature
                      </div>
                  </div>
    
                  <div class="row faketablerow text-left" *ngFor="let scan of enginesScan">
                      <div class="col-2 faketablecell text-left">
                          {{scan.name}}
                      </div>
                      <div class="col-2 faketablecell text-left">
                          {{scan.version}}
                      </div> 
                      <div class="col-3 faketablecell text-left">
                          {{scan.analysisDate | date: 'dd/MM/yyyy HH:mm'}}
                      </div>
                      <div class="col-2 faketablecell text-left">
                        {{scan.updateDate}}
                      </div>
                      <div class="col-3 faketablecell text-right">
                        <span class="badge badge-success" *ngIf="!scan?.error">
                          Clean
                        </span>
                        <span class="badge badge-danger" *ngIf="scan?.error">
                          {{scan.error}}
                        </span>
                      </div>
                  </div>
      
      </div>
    </div>
</div>

<div class="card-body" *ngIf="page == 'details'">
  <div class="row pt-3">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="detail-panel" *ngIf="vitalBasicProperties">
        <p class="h4 font-bold">
          Basic Properties
        </p>
        <table class="table table-sm">
          <tbody>
            <tr>
              <th scope="row"><p class="text-muted mb-0">MD5</p></th>
              <td>{{vitalBasicProperties.md5}}</td>
            </tr>
            <tr>
              <th scope="row"><p class="text-muted mb-0">SHA1</p></th>
              <td>{{vitalBasicProperties.sha1}}</td>
            </tr>
            <tr>
              <th scope="row"><p class="text-muted mb-0">SHA256</p></th>
              <td>{{vitalBasicProperties.sha256}}</td>
            </tr>
            <tr>
              <th scope="row"><p class="text-muted mb-0">SSDEEP</p></th>
              <td>{{vitalBasicProperties.ssdeep}}</td>
            </tr>
            <tr>
              <th scope="row"><p class="text-muted mb-0">MIME Type</p></th>
              <td>{{vitalBasicProperties.mimeType}}</td>
            </tr>
            <tr>
              <th scope="row"><p class="text-muted mb-0">MIME Encoding</p></th>
              <td>{{vitalBasicProperties.mimeEncoding}}</td>
            </tr>
            <tr>
              <th scope="row"><p class="text-muted mb-0">File Size</p></th>
              <td>{{vitalBasicProperties.fileSize | humanFileSize}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row detail-panel" *ngIf="vitalHistory">
        <p class="h4 font-bold">
          History
        </p>
        <table class="table table-sm">
          <tbody>
            <tr>
              <th scope="row"><p class="text-muted mb-0">First submission</p></th>
              <td *ngIf="isDateDefined(vitalHistory?.lastAnalysis)">{{vitalHistory.firstSubmission | date: 'dd/MM/yyyy HH:mm'}}</td>
              <td *ngIf="!isDateDefined(vitalHistory?.lastAnalysis)">--</td>
            </tr>
            <tr>
              <th scope="row"><p class="text-muted mb-0">Last submission</p></th>
              <td *ngIf="isDateDefined(vitalHistory?.lastAnalysis)">{{vitalHistory.lastSubmission | date: 'dd/MM/yyyy HH:mm'}}</td>
              <td *ngIf="!isDateDefined(vitalHistory?.lastAnalysis)">--</td>
            </tr>
            <tr>
              <th scope="row"><p class="text-muted mb-0">Last analysis</p></th>
              <td *ngIf="isDateDefined(vitalHistory?.lastAnalysis)">{{vitalHistory.lastAnalysis | date: 'dd/MM/yyyy HH:mm'}}</td>
              <td *ngIf="!isDateDefined(vitalHistory?.lastAnalysis)">--</td>
            </tr>
          </tbody>
        </table>
      </div>
    
    <div class="row detail-panel" *ngIf="vitalNames">
      <p class="h4 font-bold">
        Names
      </p>
      <p *ngFor="let name of vitalNames">{{name}}</p>
    </div>
    <div class="row detail-panel" *ngIf="vitalExifTools">
      <p class="h4 font-bold">
        Exif Tools
      </p>
      <table class="table table-sm">
        <tbody>
          <tr *ngFor="let prop of vitalExifTools">
            <th scope="row"><p class="text-muted mb-0">{{prop.name}}</p></th>
            <td>{{prop.value}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row detail-panel" *ngIf="vitalTrid">
      <p class="h4 font-bold">
        Trid
      </p>
      <p *ngFor="let trid of vitalTrid">{{trid}}</p>
    </div>
  </div>
</div>
</div>

<div class="card-body" *ngIf="page == 'links'">
  <br/>
  <br/>
  <div class="row pt-3">
    <div class="col-1"></div>
    <div class="col-10">
  <ngb-alert type="warning"
    [dismissible]="false">
    No Records
  </ngb-alert>
  </div>
  </div>
</div>



<!-- div class="card-body justify-content-center p-t-1 p-3" *ngIf="(page === 'assets' || page === 'flagged') && assetsLoaded">
    <ngb-pagination [collectionSize]="assets.length" pageSize="12" page="currentPage" [(page)]="currentPage" [maxSize]="10" aria-label="Pagination" (pageChange)="onPageChange($event)">
        <ng-template ngbPaginationPrevious></ng-template>
        <ng-template ngbPaginationNext></ng-template>
    </ngb-pagination>
</div> -->
